module.exports = __webpack_public_path__ + "img/paisajecontactusdesktop.41d04b9c.jpg";